/**
 * The kind of workflow a request runs through.
 */
export const WorkflowTypeEnum = {
  ACCESS_REQUEST: 'ACCESS_REQUEST',
  ASSESSMENT: 'ASSESSMENT',
  CATALOGUE_PURCHASE: 'CATALOGUE_PURCHASE',
  EXTERNAL_WORKFLOW: 'EXTERNAL_WORKFLOW',
  NEW_PURCHASE: 'NEW_PURCHASE',
  RENEWAL: 'RENEWAL',
  UPDATE_PURCHASE: 'UPDATE_PURCHASE',
} as const

export type WorkflowTypeEnum = (typeof WorkflowTypeEnum)[keyof typeof WorkflowTypeEnum]

/**
 * Publication state of a workflow.
 */
export const WorkflowStateEnum = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  UNDER_MAINTENANCE: 'UNDER_MAINTENANCE',
} as const

export type WorkflowStateEnum = (typeof WorkflowStateEnum)[keyof typeof WorkflowStateEnum]

/**
 * Returns whether the workflow type is triggered by a requestor submitting a request
 */
export const isRequestorWorkflowType = (type: WorkflowTypeEnum): boolean =>
  type === WorkflowTypeEnum.NEW_PURCHASE || type === WorkflowTypeEnum.UPDATE_PURCHASE
